// cart-remove-fix.js
// Behebt Fehler im Mini-Warenkorb beim "Entfernen"-Button:
// Shopify.changeItem() interpretierte den uebergebenen Wert falsch ("Cannot
// find variant" bzw. "keine gueltigen ID- oder Zeilenparameter"). Fix: direkte
// Anfrage an /cart/change.js mit explizitem 'line'-Parameter, genau wie die
// bereits funktionierenden Mengen-Plus/Minus-Buttons im selben Warenkorb.
// Die Zeilennummer wird aus der Position des Buttons in der sichtbaren Liste
// berechnet (kein data-line-Attribut noetig, daher keine Aenderung an
// theme.js selbst erforderlich).
(function ($) {
  $(function () {
    // alten, fehlerhaften Handler entfernen
    $(document).off('click', '.js-remove-mini-cart');

    // korrigierten Handler neu registrieren
    $(document).on('click', '.js-remove-mini-cart', function () {
      var itemId = $(this).data('id');
      var itemLine = $('.js-remove-mini-cart').index(this) + 1;
      var isOuterMiniCart = $(this).closest('.js-mini-cart').length === 0;

      $(this).parents('.mini-cart-item').fadeOut();

      if (window.theme && theme.GiftWrap && typeof theme.GiftWrap.checkGift === 'function') {
        theme.GiftWrap.checkGift(itemId);
      }

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + itemLine,
        dataType: 'json',
        success: function (cart) {
          // Anzeige direkt aus der frischen Antwort aktualisieren (kein erneuter Abruf noetig)
          $('.js-cart-count').text(cart.item_count);
          if (window.theme && theme.Currency) {
            $('.js-cart-total').html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
          }
          if (cart.item_count === 0) {
            $('.js-cart-bottom, .drawer-crossell').hide(100);
          }
          if (window.theme && theme.miniCart && typeof theme.miniCart.generateCart === 'function') {
            theme.miniCart.generateCart();
          }
        },
        error: function (xhr) {
          console.error('Fehler beim Entfernen des Artikels:', xhr.responseText);
          if (window.theme && theme.miniCart && typeof theme.miniCart.generateCart === 'function') {
            theme.miniCart.generateCart();
          }
        }
      });
    });
  });
})(jQuery);
